import { TrendingUp } from "lucide-react"
import { SectionReveal, StaggerReveal, StaggerItem } from "~/components/company/SectionReveal"

const results = [
  {
    metric: "30 Days",
    description: "Average time to MVP launch",
    details: "From discovery to live product with real users"
  },
  {
    metric: "2x ROI",
    description: "Typical return on investment",
    details: "Most founders see 2-10x revenue within 6 months of launch"
  },
  {
    metric: "$0 Overhead",
    description: "No hiring costs or management",
    details: "No recruiting, no onboarding, no HR costs"
  },
  {
    metric: "100% Ownership",
    description: "You own all code and IP",
    details: "Full documentation, source code access, training included"
  }
]

export function ProofSection() {
  return (
    <section className="w-full bg-slate-50 py-16 md:py-20 lg:py-24">
      <div className="container px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto space-y-16">
          <SectionReveal className="space-y-4 text-center">
            <p className="text-[#ed2132] font-semibold">RESULTS</p>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
              Proven Track Record
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Real outcomes for real founders and teams.
            </p>
          </SectionReveal>

          <StaggerReveal className="grid grid-cols-1 md:grid-cols-2 gap-8" staggerDelay={0.1}>
            {results.map((result, index) => (
              <StaggerItem key={index}>
                <div className="bg-white border border-slate-200 rounded-lg p-8 space-y-3 hover:shadow-lg hover:border-slate-300 transition-all duration-300">
                  <div className="flex items-start justify-between">
                    <div className="space-y-2">
                      <p className="text-slate-600 text-sm font-semibold">TYPICAL RESULT</p>
                      <p className="text-4xl font-bold text-[#ed2132]">{result.metric}</p>
                    </div>
                    <TrendingUp className="w-8 h-8 text-[#ed2132]/30 flex-shrink-0" />
                  </div>
                  <div className="space-y-1">
                    <p className="text-lg font-semibold text-slate-900">{result.description}</p>
                    <p className="text-slate-600 text-sm">{result.details}</p>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </StaggerReveal>
        </div>
      </div>
    </section>
  )
}
